import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { AppFormAction } from ".";
import { initialAppFormState } from "./appForm.types";
import { CLEAR_APP_FORM_STATE, FETCH_APP_FORMS_LIST_FAILED, FETCH_APP_FORMS_LIST_PROGRESS, FETCH_APP_FORMS_LIST_SUCCESS } from "./appFormActions";

export const appFormReducer = (
  state: IStoreState["appForm"] = initialAppFormState,
  action: AppFormAction
) => {
  switch (action.type) {
    case FETCH_APP_FORMS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_APP_FORMS_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_APP_FORMS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case CLEAR_APP_FORM_STATE: {
      return initialAppFormState;
    }

    default: {
      return state;
    }
  }
};
